import axios from './axios';

export default {
  get: () => axios.get('/esr'),
  esrs: () => axios.get('/esrs'),
  save: (params) => axios.put('/esr', {
    esr: params,
  }),
};
